import { atom } from "recoil";
import { AtomKeys } from "stores/storeKeys";
import { RespondentFormStateType } from "./respondentFormState";
/**
 * クイズ回答者の状態
 */
export type QuizRespondentStateType = {
  id: number;
  page: "top" | "mail" | "form" | "question" | "result";
  preview: boolean;
  answers: {
    no: number;
    title: string;
    answerOptionNo: number;
    answerOptionTitle: string;
    correctOptionNo: number;
    correctOptionTitle: string;
    reportMailDescriptionHtml: string;
  }[];
  respondentForm: RespondentFormStateType;
};

export const QuizRespondentState = atom<QuizRespondentStateType>({
  key: AtomKeys.QUIZ_RESPONDENT_STATE,
  default: {
    id: null,
    page: "top",
    preview: false,
    answers: [],
    respondentForm: null,
  },
});
